var initialized = false;
var pageConfig = window.pageConfig;
var validate = pageConfig.validate;
var i18n = require('i18n');
var util = require('../../app/util');
var cloneProjectLayer = require('./cloneProjectLayer.html');
$('body').append(cloneProjectLayer({}));

$.fn.form.settings.rules.projectNameForbidTest = function(value) {
  return !!value.indexOf('test');
};

module.exports = function(success) {
  if (initialized) {
    return;
  }
  initialized = true;
  var layer = $('.clone-project-layer');
  layer.form({
    inline: true,
    on: 'blur',
    fields: {
      name: {
        identifier: 'name',
        rules: [{
          type: 'empty',
          prompt: i18n('tip.input.project.name')
        }, {
          type: 'maxLength[' + validate.maxProjectName + ']',
          prompt: i18n('tip.project.name.length', { min: validate.minProjectName, max: validate.maxProjectName })
        }, {
          type: 'minLength[' + validate.minProjectName + ']',
          prompt: i18n('tip.project.name.length', { min: validate.minProjectName, max: validate.maxProjectName })
        }, {
          type: 'projectNameForbidTest',
          prompt: i18n('startWithTest')
        }]
      },
      desc: {
        identifier: 'desc',
        rules: [{
          type: 'maxLength[' + validate.maxDescription + ']',
          prompt: i18n('tip.project.description.length', { max: validate.maxDescription })
        }]
      },
    },
    onSuccess: function(e, data) {
      var pid = layer.data('pid');
      data.cloneProjectName = layer.data('pname');
      layer.find('.close').click();
      // Add waiting animate...
      var $loaderMask = $('<div>').addClass('loader-mask')
          .css('height', $('body').height())
          .appendTo($('body'));

      var $loader = $('<div>').addClass('loader')
          .append('<div></div>')
          .append('<span>' + i18n('wait.project.clone') + '</span>' )
          .appendTo($('body'));

      util.loadData('/project/' + pid + '/clone', data, 'POST', function (res) {
        success(res.data);
        $loaderMask.fadeOut(600, function() {
          $loaderMask.remove();
        });
        $loader.fadeOut(600, function() {
          $loader.remove();
        });
      });
    }
  });

  layer.find('.close').click(function() {
    layer.modal('hide');
  });
}


// WEBPACK FOOTER //
// ./src/pages/home/cloneProject.js